<!--Scroll to top-->
<div theme class="hvt-scroll-to-top" [ngClass]="{'hvt-show-scrollTop': windowScrolled}" (click)="scrollToTop()">
        <i class="fa fa-chevron-up"></i>
</div>